import { FC } from "react";

interface InformationalIconSVGProps {
    className?: string;
}

const InformationalIconSVG: FC<InformationalIconSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M16 21.3346V16.0013M16 10.668H16.0134M29.3334 16.0013C29.3334 23.3651 23.3638 29.3346 16 29.3346C8.63622 29.3346 2.66669 23.3651 2.66669 16.0013C2.66669 8.63751 8.63622 2.66797 16 2.66797C23.3638 2.66797 29.3334 8.63751 29.3334 16.0013Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default InformationalIconSVG;
